import token from '@uipath/apollo-core/lib';
export const MuiInputBase = (palette) => ({
    root: {
        '&.Mui-disabled': {
            color: palette.semantic.colorForegroundDisable,
            backgroundColor: palette.semantic.colorBackgroundDisabled,
            background: palette.semantic.colorBackgroundDisabled,
        },
        '&.Mui-error': { '.MuiOutlinedInput-notchedOutline': { borderColor: `${palette.semantic.colorErrorText} !important` } },
    },
    input: {
        fontSize: token.FontFamily.FontMSize,
        fontFamily: token.FontFamily.FontNormal,
        '&.Mui-disabled': {
            color: palette.semantic.colorForegroundDisable,
            backgroundColor: palette.semantic.colorBackgroundDisabled,
            background: palette.semantic.colorBackgroundDisabled,
        },
    },
});
